// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@sc/App/Components/Common/XngZone";
import { XNGAGE_CUSTOM_WIDGET } from "@sc/XDL/constants";
import React from "react";

export interface SlideShowContainerStyles {
    container?: InjectableCss;
    eSpotWrapper?: InjectableCss;
    slideShowWrapper?: InjectableCss;
}

export const slideShowContainerStyles: SlideShowContainerStyles = {};
const styles = slideShowContainerStyles;

const SlideShowContainer: React.FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} className="SlideShow-container">
            <StyledWrapper {...styles.slideShowWrapper} className="SlideShow-wrapper">
                <XngZone contentId={id} zoneName="SlideShow" hint="Zone For SlideShow" />
            </StyledWrapper>
            <StyledWrapper {...styles.eSpotWrapper} className="espot-wrapper">
                <XngZone contentId={id} zoneName="espot" hint="Zone For E-Spot" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export const definition: WidgetDefinition = {
    displayName: "SlideShow Container",
    group: XNGAGE_CUSTOM_WIDGET,
};

const widgetModule: WidgetModule = {
    component: SlideShowContainer,
    definition,
};

export default widgetModule;
